import React, { useEffect, useState } from 'react';
import { sessionUsersAtom } from '../../../State';
import { useRecoilValue } from 'recoil';

export const ViewerCount = ({ isMouseOver }) => {
  const [viewCountState, setViewCountState] = useState(1);
  const sessionUsers = useRecoilValue(sessionUsersAtom);
  //const [existingUserArrayState, setExistingUserArrayState] = useState([]);

  //セッション情報を元に更新
  useEffect(() => {
    setViewCountState(Object.keys(sessionUsers).length);
  }, [sessionUsers]);

  //セッション情報を元に更新
  useEffect(() => {
    if (Object.keys(sessionUsers).length > 0) {
      var existingUserIDs = [];
      var existingUserName = [];
      var finalUsers = [];

      //オブジェクトとしてユーザーの処理
      Object.keys(sessionUsers).forEach(function (key) {
        var user = sessionUsers[key];

        var flg = true;
        var existingUserNameFlg = true;

        //重複を削除
        if (user.userID != null) {
          if (existingUserIDs.includes(user.userID) == false) {
            existingUserIDs.push(user.userID);
          } else {
            flg = false;
          }
        }

        //名前の重複削除
        if (user.displayName != null) {
          if (existingUserName.includes(user.displayName) == false) {
            existingUserName.push(user.displayName);
          } else {
            //existingUserNameFlg = false;
          }
        }

        if (flg && existingUserNameFlg) {
          finalUsers.push(user.userID);
        }
      });

      setViewCountState(finalUsers.length);

      //setExistingUserArrayState(finalUsers);
    }
  }, [sessionUsers]);

  return <>{viewCountState}</>;
};
